import { autoWebViewJs } from "@droid/android";
import { Button } from "@mui/material";
import { useTranslation } from "@fanfanlo";

export function ScaneQRCodeButton() {

    const {t} = useTranslation('homepage/components/notification-listener/content');
    function onClick(){
        const script = `
        com.fanfanlo.lib.notification.NotificationScanQRCode.scanQRCode()
        `
        autoWebViewJs.callScript(script);
    }
    return (
        <>
        <Button variant="outlined" onClick={onClick} data-testid="ScaneQRCodeButton__scanButton__01JG2B0083" data-test-comment="扫描二维码按钮，点击后调用系统二维码扫描功能">{t("ScaneQRCodeButton.name")}</Button>
        </>
    )
}   